var map = {
	"./de.json": 12514,
	"./en-us.json": 4991,
	"./es.json": 24659,
	"./fi.json": 21714,
	"./fr-ca.json": 56638,
	"./fr.json": 54465,
	"./it.json": 35787,
	"./ja.json": 33587,
	"./nl.json": 75350,
	"./no.json": 95774,
	"./pt.json": 92616,
	"./sv.json": 57137,
	"./zh-cn.json": 9399,
	"./zh-tw.json": 60367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42969;